module.exports = "./img/0782f74aea6ecb3fd09c9a8d216d2e62.png";